import { render, staticRenderFns } from "./step-custom-price.vue?vue&type=template&id=1db23d7d&scoped=true&"
import script from "./step-custom-price.vue?vue&type=script&lang=js&"
export * from "./step-custom-price.vue?vue&type=script&lang=js&"
import style0 from "./step-custom-price.vue?vue&type=style&index=0&id=1db23d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db23d7d",
  null
  
)

export default component.exports